(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp-browse-flow-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    function isStandaloneProductView() {
      return new URLSearchParams(window.location.search).get('product_view') === 'standalone';
    }

    function withStandaloneProductView(href) {
      var url = new URL(href || '/collections/shop-all', window.location.origin);
      url.searchParams.set('product_view', 'standalone');
      return url.pathname + url.search + url.hash;
    }

    function syncBrowseFlowCtas() {
      var standaloneProductView = isStandaloneProductView();

      document.querySelectorAll('[data-pdp-browse-flow-cta]').forEach(function (cta) {
        var mode = cta.getAttribute('data-pdp-browse-flow-cta');
        cta.hidden = mode === 'standalone' && !standaloneProductView;
      });

      if (!standaloneProductView) return;

      document.querySelectorAll('[data-pdp-standalone-url], .pdp-back-link[href]').forEach(function (link) {
        link.setAttribute('href', withStandaloneProductView(link.getAttribute('href')));
      });
    }

    syncBrowseFlowCtas();
    document.addEventListener('DOMContentLoaded', syncBrowseFlowCtas);
    document.addEventListener('shopify:section:load', syncBrowseFlowCtas);
  })();
  } catch(e) { console.error(e); }
})();

})();
